import { Injectable, inject, signal } from '@angular/core';
import { GhostPlayerComponent } from '@components/athena-player/ghost-player/ghost-player.component';
import {
  GetTrailerDocument,
  GetTrailerQueryVariables,
  TrailerResult,
} from '@shared/graphql/api.generated';
import { GraphqlClients, GraphqlService } from '@shared/graphql/graphql.service';

@Injectable({
  providedIn: 'root',
})
export class TrailerService {
  ghostPlayerComponent$ = signal<GhostPlayerComponent | undefined>(undefined);

  private readonly graphqlService = inject(GraphqlService);

  getTrailer(trailerID: string) {
    return this.graphqlService.makeQuery<TrailerResult, GetTrailerQueryVariables>(
      GraphqlClients.api,
      GetTrailerDocument,
      {
        trailerID,
      },
    );
  }
}
